import { render, staticRenderFns } from "./GoodPracticesPage.vue?vue&type=template&id=c8148040&scoped=true"
import script from "./GoodPracticesPage.vue?vue&type=script&lang=js"
export * from "./GoodPracticesPage.vue?vue&type=script&lang=js"
import style0 from "./GoodPracticesPage.vue?vue&type=style&index=0&id=c8148040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8148040",
  null
  
)

export default component.exports